/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';
import PropTypes from 'prop-types';

var SymbolSquare = function SymbolSquare(_ref) {
    var x = _ref.x,
        y = _ref.y,
        size = _ref.size,
        fill = _ref.fill;
    return React.createElement('rect', { x: x, y: y, fill: fill, width: size, height: size });
};

SymbolSquare.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired
};

export default SymbolSquare;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/legends/es/svg/symbols/SymbolSquare.js
// module id = 1501
// module chunks = 0